import jwtDefaultConfig from './jwtDefaultConfig'
import {initialAbility} from "@/libs/acl/config"

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null
  #vue = null;

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      (config) => {
        // Get token from localStorage
        const accessToken = this.getToken()

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      (response) => response,
      (error) => {
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        // if (status === 401) {
        if (response && response.status === 401) {
          if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true
            this.refreshToken()
                .then((r) => {
                  this.isAlreadyFetchingAccessToken = false

                  // Update accessToken in localStorage
                  this.setToken(r.data.access_token)
                  this.setRefreshToken(r.data.access_token)

                  this.onAccessTokenFetched(r.data.access_token)
            })
                .catch(() => {
                  this.onExpiredToken()
                })
          }

          const retryOriginalRequest = new Promise((resolve) => {
            this.addSubscriber((accessToken) => {
              // Make sure to assign accessToken according to your response.
              // Check: https://pixinvent.ticksy.com/ticket/2413870
              // Change Authorization header
              originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
              resolve(this.axiosIns(originalRequest))
            })
          })
          return retryOriginalRequest
        }

        if (response && (response.status === 422 || response.status === 500) && process.env.VUE_APP_SENDERRORS) {
            const errors = response.data.errors ? JSON.stringify(response.data.errors) : ''
            const text = `${response.data.message}

            ${errors}`
            this.axiosIns.post(`${process.env.VUE_APP_TELEGRAM_API}${process.env.VUE_APP_TELEGRAM_TOKEN}/sendMessage`, {
                chat_id: process.env.VUE_APP_TELEGRAM_CHAT_ID,
                text
            })
        }
        return Promise.reject(error)
      }
    )
  }

  attachVueInstance(vue) {
    this.#vue = vue
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter((callback) => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
     return this.axiosIns.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken()
    })
  }

  onExpiredToken() {
    localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
    localStorage.removeItem(this.jwtConfig.storageRefreshTokenKeyName)

    // Remove userData from localStorage
    localStorage.removeItem('userData')

    // Reset ability
    this.#vue.$ability.update(initialAbility)

    // Redirect to login page
    this.#vue.$router.push({ name: 'login' })
  }
}
